import { ADD_MYACCOUNT } from './actions';

// Initial State
const initialState = {
  isAdding: 'True',
  isAdded: 'False',
  isAddedFailed: 'False',
};

const MyAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MYACCOUNT:
      return Object.assign({}, state, {
        isAdding: 'False',
        isAdded: 'True',
        isAddedFailed: 'False',
      });

    default:
      return state;
  }
};

export default MyAccountReducer;



// WEBPACK FOOTER //
// ./src/views/myaccount/reducer.js